module.exports = __webpack_public_path__ + "img/explain.038074e8.png";